module.exports = __webpack_public_path__ + "img/good.2d0db559.svg";